import React from 'react';
import {useTranslation} from "../../hooks/useTranslation";

export function NoResultMessage() {

    const translate = useTranslation();

    return (
        <>
            {translate('no_result')}
        </>
    );
}
